// info.js
import { db } from './firebaseConfig'; // Adjust path to your Firebase config
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export async function fetchInfo() {
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const connection = navigator.connection || {};

  const clientInfo = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    languages: navigator.languages,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    utcOffsetMinutes: new Date().getTimezoneOffset(),
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    platform: navigator.platform,
    isMobile: isMobile,
    hardwareConcurrency: navigator.hardwareConcurrency || 'unknown',
    deviceMemoryGB: navigator.deviceMemory || 'unknown',
    cookiesEnabled: navigator.cookieEnabled,
    doNotTrack: navigator.doNotTrack,
    touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    networkType: connection.type || 'unknown',
    effectiveConnectionType: connection.effectiveType || 'unknown',
    downlinkMbps: connection.downlink || 'unknown',
    ip: null,
    location: null,
    isp: null,
    timestamp: serverTimestamp()
  };

  try {
    const res = await fetch('https://ipapi.co/json/');
    if (!res.ok) throw new Error('Geo-IP fetch failed');
    const data = await res.json();

    clientInfo.ip = data.ip;
    clientInfo.location = `${data.city}, ${data.region}, ${data.country_name}`;
    clientInfo.isp = data.org;
  } catch (error) {
    console.warn('IP/Location fetch error:', error.message);
  }

  // ✅ Save to Firebase
  try {
    await addDoc(collection(db, 'logs'), clientInfo);
  } catch (err) {
    console.error('Error logging to Firebase:', err);
  }
}
